module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v("Dependencies")]), _vm._v(" "), _c('div', {
    staticClass: "dependency-shields-container"
  }, [_vm._l((_vm.dependencies), function(dependency) {
    return [_c('div', {
      staticClass: "pure-g dependency-list-container"
    }, [_c('div', {
      staticClass: "pure-u-1-8 delete-button"
    }, [_vm._v("X")]), _vm._v(" "), _c('div', {
      staticClass: "pure-u-7-12 dependency-list-container__name",
      domProps: {
        "textContent": _vm._s(dependency.name)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "pure-u-7-24 dependency-list-container__version",
      domProps: {
        "textContent": _vm._s(dependency.version)
      }
    })])]
  }), _vm._v(" "), (_vm.dependencies.length !== 0) ? _c('div', {
    staticClass: "divider"
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "dependency-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependencyName),
      expression: "dependencyName"
    }],
    ref: "dependencyNameInput",
    staticClass: "dependency-name",
    attrs: {
      "spellcheck": "false",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.dependencyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dependencyName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependencyVersion),
      expression: "dependencyVersion"
    }],
    staticClass: "dependency-version",
    attrs: {
      "spellcheck": "false",
      "placeholder": "Version"
    },
    domProps: {
      "value": (_vm.dependencyVersion)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.addDependency($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dependencyVersion = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('vue-r-button', {
    attrs: {
      "label": 'Add Dependency',
      "onClick": _vm.addDependency
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3dc6ac1c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/configuratorListAdd.vue
// module id = 64
// module chunks = 0